// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";

// Components Imprts
import FormView from "../FormView";
import ClickToFill from "./ClickToFill";

// Internal Imports
import { DOCUMENTVIEW_MODE } from "../constants";
import { DocumentUtils } from "../../../utils";

// Destructuring
const { isDocBandAvailabel } = DocumentUtils;
const { FORMVIEW } = DOCUMENTVIEW_MODE;

class DocForm extends Component {
  state = {
    formTop: 148, // this is the current default starting  position of the doc canvas
  };

  componentDidMount() {
    this._setFormTop();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isLocked !== this.props.isLocked) {
      this._setFormTop();
    }
  }

  _setFormTop = () => {
    const ele = document.getElementById("document-view-container");
    if (ele) {
      const { top } = ele.getBoundingClientRect();
      if (top < 0) {
        const setTop = this.props.isLocked ? 208 : 147;
        this.setState({ formTop: setTop });
      } else {
        this.setState({ formTop: top });
        const eleWithCover = document.getElementsByClassName(
          "document-coverpage",
        );
        if (eleWithCover[0].hasChildNodes()) {
          this.setState({ formTop: top + 7.5 });
        }
      }
    }
  };

  render() {
    const disableEdit = this.props.isLocked || this.props.isSharedDocument;
    // enable form mode for sent for acceptance
    const disableFormMode = disableEdit && !this.props.showForm;

    // "checkDocBand" this is being used for form view section height
    // ex: in case of document band, need to reduce the form view section height
    let checkDocBand = false;
    if (
      this.props.showForm &&
      this.props.currentView === FORMVIEW &&
      !disableFormMode &&
      this.props.formOpen &&
      this.props.formCanRender
    ) {
      checkDocBand = isDocBandAvailabel(
        this.props.stage,
        this.props.docRecipientList,
        this.props.acceptorsList,
        this.props.mode,
        this.props.isSharedDocument,
        this.props.pendingApprovalRequired,
        this.props.docApprovalStatus,
        this.props.paymentStatus,
      );
    }

    return (
      <div className="new-toggle-form">
        {this.props.showForm &&
        this.props.currentView === FORMVIEW &&
        !disableFormMode &&
        this.props.formOpen &&
        this.props.formCanRender &&
        (this.props.recipientType !== "ACCEPTOR" &&
          this.props.recipientType !== "REVIEWER") ? (
          <FormView
            formFields={this.props.formFields}
            show={this.props.currentView === FORMVIEW}
            switchView={this.props.switchView}
            formView={this.props.toggleFormView}
            formTop={this.state.formTop}
            formCanRender={this.props.formCanRender}
            sharingHash={this.props.sharingHash}
            isSharedDocument={this.props.isSharedDocument}
            docID={this.props.docID}
            isDocBandAvailabel={checkDocBand}
          />
        ) : (
          this.props.recipientType !== "ACCEPTOR" &&
          this.props.recipientType !== "REVIEWER" &&
          this.props.showForm && (
            <ClickToFill formTop={this.state.formTop} {...this.props} />
          )
        )}
      </div>
    );
  }
}

export default connect()(DocForm);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DocForm/index.js